export const environment = {
  COMPANYID: "MTczMjI=",
  COMPANYURL: "c2VsZWMucHJlcHJvZDEub3BlbmluZ3MuY28vIyEvL21hbmFnZQ==",
  DOMAIN: "selec.preprod1.openings.co",
  APIENDPOINT: "https://apipreprod1.zwayam.com/",
  APIENDPOINTNEW: "https://apipreprod1.zwayam.com/",
  JOBSHAREURL: "https://apipreprod1.zwayam.com",
  TENANTAPIURL : "https://apipreprod1.zwayam.com"
};